import { createSlice } from "@reduxjs/toolkit";
const currentTab = 1;
const currentTabSlice = createSlice({
  name: "currentTab",
  initialState: {
    currentTab,
  },
  reducers: {
    reSetCurrentTabData(state, action){
      state.currentTab = currentTab
    },
    setCurrentTabData(state, action) {
      state.currentTab = action.payload;
    },
  },
});

export const { setCurrentTabData ,reSetCurrentTabData} = currentTabSlice.actions;

export default currentTabSlice.reducer;
